import { Box, Container, Grid, Link, Stack, Typography, useTheme } from "@mui/material";
import Layout from "src/components/core/Layout";
import Title from "src/components/common/Title";
import { useIsMobile } from "src/utils/hooks/useIsMobile";
import { trackEvent } from "src/Amplitude";
import { useEffect } from "react";

const Research = () => {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const userDevice = isMobile ? "Mobile" : "Desktop";

  useEffect(() => {
    trackEvent(`Visit_Page`, {
      page: "Research",
      userDevice,
    });
  }, []);

  const smartContractPlatformsUrl =
    "https://assets.ctfassets.net/4ua9vnmkuhzj/6I9fUaNCJazNBELvtnKIXr/3f95319591a70e9c50d493225120fabe/Research_Report_-_Smart_Contract_Platforms.pdf";

  const deFiPlatformsUrl =
    "https://assets.ctfassets.net/4ua9vnmkuhzj/2iIwgWQLqEri8kxozreEXW/fedcb01192f05554cfae531e0e387a9b/Research_Report_-_DeFi_Platforms.pdf";

  const exchangeTradedFuldsUrl =
    "https://assets.ctfassets.net/4ua9vnmkuhzj/2fMOekw7Youe4DjkNVdiKQ/7c24c0dd8cc1a1b7c2d87a543ea7cba0/Research_Report_-_Exchange_Traded_Funds.pdf";

  const cryptoAIUrl =
    "https://assets.ctfassets.net/4ua9vnmkuhzj/3EaTwUbcb93rGLbcmektxL/0d5cc00f956f380550cb6b4efddaab31/Caleb___Brown_Research_-_Crypto_x_AI.pdf";

  const emerginSectorsUrl =
    "https://assets.ctfassets.net/4ua9vnmkuhzj/31zPjYpz65RX0oyqfEGx9E/515c2126ee3771dd0e0be560b10b6b63/Caleb___Brown_Research_-_Emerging_Sectors.pdf";

  const realWorldAssets =
    "https://assets.ctfassets.net/4ua9vnmkuhzj/4jFQAmbttMNAqPIGPZjfpX/3f0e181bbd317525bfd107bde932c78d/Caleb___Brown_Research_-_Real_World_Assets.pdf";

  const cryptoMarketOutlook =
    "https://assets.ctfassets.net/4ua9vnmkuhzj/IToI7MaaU3V5vLiwc8OPl/234075aa5c949987f433d52f0a54dd9c/Crypto_Market_Outlook_Q4_2024.pdf";

  const insideMarkets =
    "https://assets.ctfassets.net/4ua9vnmkuhzj/7KUGQOvGudwOEdeCaMMYpO/12800762573bb92044306a8720d2c84b/Inside_the_Markets_-_Nov_2024.pdf";

  const insideMarketsDec =
    "https://assets.ctfassets.net/4ua9vnmkuhzj/6pu1kGFGecm3He3fsGZ1ID/73e5703e14715180267b2b7fdb0ab354/Crypto_Market_Outlook_-_Dec_2024.pdf";

  const insideMarketsFeb =
    "https://assets.ctfassets.net/4ua9vnmkuhzj/6L59G1rghGDiYiZg6r0b6L/a74b597a1a1f66a3b215510969bd0949/Inside_the_Markets_-_Feb_2025.pdf";

  const insideMarketsMarch =
    "https://assets.ctfassets.net/4ua9vnmkuhzj/5VIDHWIspAQXTkWGehAGgj/572f8f12e5e127656ab6493a151cb34c/Inside_the_Markets_-_Mar_2025.pdf";

  const insideMarketsApril =
    "https://assets.ctfassets.net/4ua9vnmkuhzj/6WzSmGy2lAgFyVxDp41Oxc/90e73801452e7aeed52dac331610496d/Inside_the_Markets_-_Apr_2025.pdf";

  const insideMarketsMay =
    "https://assets.ctfassets.net/4ua9vnmkuhzj/7JmNhNdvJ4rSjI3Sgv1D4X/9a25d0a9ab1314560ed86ea6087636ca/Inside_the_Markets_-_May_2025.pdf";

  const insideMarketsJun =
    "http://assets.ctfassets.net/4ua9vnmkuhzj/4bsPi8MZ2EOudpnyR9LsEJ/d422590bdbb1f6d6f2fff80e75032bb4/Inside_the_Markets_-_Jun_2025.pdf";

  const insideMarketsJul =
    "https://assets.ctfassets.net/4ua9vnmkuhzj/2Is1W4Ib99vYMWq3u0f3zr/4d671524ed4992e5719fd0b6328ffd61/Inside_the_Markets_-_Jul_2025.pdf";

  const insideMarketsAug =
    "https://assets.ctfassets.net/4ua9vnmkuhzj/4udy3Kl85sJp9TRpAFU1gI/d3a441959230588d03cf3395595dfe44/Inside_the_Markets_-_Aug_2025.pdf";

  const insideMarketsSep =
    "https://assets.ctfassets.net/4ua9vnmkuhzj/1tugAkNP5iZeLfpwxhpvca/4fa457f711875837660574bb09b49287/Inside_the_Markets_-_Sep_2025.pdf";

  const insideMarketsOct =
    "https://assets.ctfassets.net/4ua9vnmkuhzj/4LV2pxMxXM4kkm83iBfoHD/472e4145b6c6cebc7f9ee7216bd16c5d/Inside_the_Markets_-_Oct_2025.pdf";

  const insideMarketsNov =
    "https://assets.ctfassets.net/4ua9vnmkuhzj/3Mi0qKEzkU9siTgAlQhHiV/02aa410316ec189736b4ddb0594f1f91/Inside_the_Markets_-_Nov_2025.pdf";

  const insideMarketsDec25 =
    "https://assets.ctfassets.net/4ua9vnmkuhzj/5zXC7tI5GC30PPvHwoKPKe/2927ca57750f330e512208503df2ca78/Inside_the_Markets_-_Dec_2025.pdf";

  const insideMarketsJan26 =
    "https://assets.ctfassets.net/4ua9vnmkuhzj/641GP8XHtmzTnfvFZLfTAK/c2cc219a3a0430bd8722b938d2fa404d/Inside_the_Markets_-_Jan_2026.pdf";

  const insideMarketsFeb26 =
    "https://assets.ctfassets.net/4ua9vnmkuhzj/1UcWWKt3VOchbI34fMp2gz/2e4a5020989be0460db655b71a824e86/Inside_the_Markets_-_Feb_2026.pdf";

  const insideMarketsMar26 =
    "https://assets.ctfassets.net/4ua9vnmkuhzj/7HRp8ADfxFUtBdHbtlKvDV/80ce793bf02dae817654151c07770a56/Inside_the_Markets_-_Mar_2026.pdf";

  const insideMarketsApr26 =
    "https://assets.ctfassets.net/4ua9vnmkuhzj/3XWAlAQ6wrTK6Oa9lPgOaC/9b2a8039de585b7370eac96b21d98ee3/Inside_the_Markets_-_Apr_2026.pdf";

  const insideMarketsMay26 =
    "https://assets.ctfassets.net/4ua9vnmkuhzj/3ac4l2eYQOTufQzRvBmcEe/35c0b5e257f205df7349cf7bf8a21b39/Inside_the_Markets_-_May_2026.pdf";

  const links = [
    {
      label: "Inside the Markets | May 2026",
      url: insideMarketsMay26,
      coverImgUrl: "/market_may_26.png",
      description:
        "April brought a recovery in risk sentiment as equities rallied and bitcoin broke back above US$80k. We explore Middle East developments, Fed uncertainty, Ethereum momentum, and key crypto catalysts to watch in May.",
    },
    {
      label: "Inside the Markets | Apr 2026",
      url: insideMarketsApr26,
      coverImgUrl: "/market_april_26.png",
      description:
        "March saw crypto and traditional markets swing on Middle East tensions, oil volatility and inflation fears, while bitcoin and ethereum showed resilience. We unpack the macro forces shaping markets and key catalysts investors are watching in April.",
    },
    {
      label: "Inside the Markets | Mar 2026",
      url: insideMarketsMar26,
      coverImgUrl: "/research_march_26.webp",
      description:
        "February saw renewed crypto volatility as macro uncertainty intensified. Bitcoin briefly fell to US$60k before stabilising, equities traded sideways. In this update, we explain macro forces shaping markets and catalysts investors are watching in March.",
    },
    {
      label: "Inside the Markets | Feb 2026",
      url: insideMarketsFeb26,
      coverImgUrl: "/market_feb26.webp",
      description:
        "Bitcoin's early-year rebound has stalled as macro pressure builds, while equities continue to push higher and gold and silver trade in wide, volatile ranges. Caleb & Brown CCO Jake Boyle breaks down what's driving markets now — and what might shift next.",
    },
    {
      label: "Inside the Markets | Jan 2026",
      url: insideMarketsJan26,
      coverImgUrl: "/market_jan.webp",
      description:
        "Bitcoin rebounded into year-end as liquidity improved and early altcoin leadership emerged. We break down the signals and catalysts shaping crypto into early 2026.",
    },
    {
      label: "Inside the Markets | Dec 2025",
      url: insideMarketsDec25,
      coverImgUrl: "/market_dec25.webp",
      description:
        "Here we cover what’s driving crypto sentiment into December, and the catalysts to watch — from global liquidity and Fed policy to crypto accumulation trends, and the key indicators that could define early 2026.",
    },
    {
      label: "Inside the Markets | Nov 2025",
      url: insideMarketsNov,
      coverImgUrl: "/market_nov.webp",
      description:
        "We break down what drove October's volatility, the Fed's divided outlook, the ongoing shutdown, and whether improving liquidity could set the stage for crypto's next major moves in November.",
    },
    {
      label: "Inside the Markets | Oct 2025",
      url: insideMarketsOct,
      coverImgUrl: "/market_oct.webp",
      description:
        "“Uptober” is here! We explore Fed policy, liquidity, altseason signals, and catalysts shaping crypto in October.",
    },
    {
      label: "Inside the Markets | Sep 2025",
      url: insideMarketsSep,
      coverImgUrl: "/market_sep.webp",
      description:
        "Markets swung in August on tariffs, inflation data, and Fed signals, while BTC hit fresh highs and ETH broke its 2021 record. We explore the “September effect,” Fed policy, and the narratives shaping crypto into year-end.",
    },
    {
      label: "Inside the Markets | Aug 2025",
      url: insideMarketsAug,
      coverImgUrl: "/market_august.webp",
      description:
        "We cover July's record highs in crypto and TradFi, the impact of U.S. tariffs, Fed policy, and the weakening dollar. Hear our outlook for Bitcoin, Ethereum, altcoins, and the macro catalysts to watch in August and beyond.",
    },
    {
      label: "Inside the Markets | Jul 2025",
      url: insideMarketsJul,
      coverImgUrl: "/market_july.webp",
      description:
        "Bitcoin's resilience underscores its role as a core institutional asset, while altcoins struggle. Macro and policy remain key drivers.",
    },
    {
      label: "Inside the Markets | Jun 2025",
      url: insideMarketsJun,
      coverImgUrl: "/market_June.webp",
      description:
        "Another bitcoin all-time high and a long awaited pump for Ethereum, PLUS further tariff uncertainty and inflation concerns ignite volatility in stocks.",
    },
    {
      label: "Inside the Markets | May 2025",
      url: insideMarketsMay,
      coverImgUrl: "/ISM_Report_May2025.webp",
      description:
        "Markets rebounded in April as selected U.S. tariffs paused and trade talks resumed. With BTC surging and institutional inflows rising, explore key macro shifts and crypto signals to watch in May.",
    },
    {
      label: "Inside the Markets | April 2025",
      url: insideMarketsApril,
      coverImgUrl: "/ISM_Report_April2025_Thumbnail.webp",
      description:
        "Tariffs, Fed policy, and crypto regulation drove March volatility. Despite short-term uncertainty, institutional buying is rising. Explore key market movers and what to watch in April’s macro and crypto landscape.",
    },
    {
      label: "Inside the Markets | March 2025",
      url: insideMarketsMarch,
      coverImgUrl: "/ISM_Report_March2025_Thumbnail.webp",
      description:
        "Crypto markets faced selling pressure despite a new U.S. administration, driven by macro events and a $1.4B Bybit hack. Explore recent volatility and key factors to watch in March.",
    },
    {
      label: "Inside the Markets | Feb 2025",
      url: insideMarketsFeb,
      coverImgUrl: "/ISM-Feb2025-ReportThumbnail.webp",
      description:
        "Volatility in back in markets as Trump tariff threats and Chinese AI challengers make headlines.",
    },
    {
      label: "Inside the Markets | Dec 2024",
      url: insideMarketsDec,
      coverImgUrl: "/Inside_the_Markets_-_Report_Cover_-_December_2024.webp",
      description:
        "Bitcoin surpasses $100K, Ethereum gains 60%, and XRP surges past $2, as pro-crypto policies and institutional interest reshape market dynamics for a strong end to 2024 and beyond.",
    },
    {
      label: "Inside the Markets | Nov 2024",
      url: insideMarkets,
      coverImgUrl: "/Nov24InsidetheMarketsReport-Thumbnail.webp",
      description:
        "Enjoy our crypto market analysis post-US presidential election, with the backdrop favorable macro tailwinds and a roaring crypto bull market.",
    },
    {
      label: "Crypto Market Outlook | Q4 2024",
      url: cryptoMarketOutlook,
      coverImgUrl: "/Q42024InsidetheMarketsReport-Thumbnail.webp",
      description:
        "Enjoy our crypto market outlook for Q4 2024 and beyond amidst the backdrop of the US presidential election, falling interest rates, and geopolitical tensions.",
    },
    {
      label: "Real World Assets",
      url: realWorldAssets,
      coverImgUrl: "/research-paper-cover-Real-World-Assets.webp",
      description:
        "Explore the transformative power of tokenisation in Real World Assets, detailing the bridge between digital and traditional assets like real estate and intellectual property.",
    },
    {
      label: "Crypto x AI",
      url: cryptoAIUrl,
      coverImgUrl: "/research-paper-cover-AI.webp",
      description:
        "Explore the dynamic intersection of Cypto & AI in this report, highlighting how decentralised technologies are reshaping data ownership and privacy in the AI sector.",
    },
    {
      label: "Emerging Sectors",
      url: emerginSectorsUrl,
      coverImgUrl: "/research-paper-cover-Emerging-Sectors.webp",
      description:
        "Navigate the frontier of innovation in Emerging Sectors, uncovering the disruptive technologies and platforms that redefine asset ownership and gaming through blockchain.",
    },
    {
      label: "Smart Contract Platforms",
      url: smartContractPlatformsUrl,
      coverImgUrl: "/research-paper-cover-Smart-Contract-Platforms.webp",
      description:
        "Explore Smart Contract Platforms, which details the advancements and competitive landscape of blockchains driving decentralised applications and financial innovations.",
    },
    {
      label: "DeFi Platforms",
      url: deFiPlatformsUrl,
      coverImgUrl: "/research-paper-cover-Defi-Platforms.webp",
      description:
        "Discover DeFi Platforms, where decentralised finance reshapes borrowing, lending, and trading without intermediaries, offering insights into the sector's growth and challenges.",
    },
    {
      label: "Exchange Traded Funds",
      url: exchangeTradedFuldsUrl,
      coverImgUrl: "/research-paper-cover-ETFs.webp",
      description:
        "Delve into Exchange Traded Funds, exploring the pivotal developments in crypto-based ETFs that shape investment landscapes and drive market evolution.",
    },
  ];

  return (
    <Layout>
      <Container>
        <Title
          title={{ partA: "Research by", partB: "Caleb & Brown" }}
          subtitle="When it comes to investing in crypto assets, it pays to have the right information.
          Unlock the potential for greater returns with our exclusive research reports. Our Broker Research Reports offer sharp, actionable insights on market sectors, crypto assets, as well as broader commentary on the overall crypto landscape.
          "
        />
        <Grid container spacing={isMobile ? 0 : 3} sx={{ mt: 5, mb: 5 }}>
          {links.map((item, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Link
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  trackEvent(`User clicked on Download ${item.label}`, { userDevice }, "Research");
                }}
                sx={{
                  display: "block",
                  position: "relative",
                  aspectRatio: "2 / 3",
                  maxWidth: isMobile ? "none" : "260px",
                  margin: isMobile ? 3 : "auto",
                  borderRadius: 2,
                  overflow: "hidden",
                  textDecoration: "none",
                  "&:hover .overlay": {
                    transform: "translateY(0)",
                  },
                  "&:hover .image": {
                    transform: "scale(1.05)",
                  },
                }}>
                <Box
                  component="img"
                  className="image"
                  src={item.coverImgUrl || "https://via.placeholder.com/400x250"}
                  alt={item.label}
                  sx={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    transition: "transform 0.3s ease-in-out",
                  }}
                />
                <Box
                  className="overlay"
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    p: 2,
                    backgroundColor: theme.palette.primary.light,
                    opacity: 0.95,
                    transform: "translateY(100%)",
                    transition: "transform 0.3s ease-in-out",
                    color: "black",
                  }}>
                  <Typography
                    fontWeight={600}
                    sx={{
                      fontSize: "16px",
                      marginBottom: "16px",
                      color: theme.palette.text.secondary,
                    }}>
                    {item.label}
                  </Typography>
                  {item.description && (
                    <Typography variant="body2" fontWeight={500} sx={{ mt: 1 }}>
                      {item.description}
                    </Typography>
                  )}
                </Box>
              </Link>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Layout>
  );
};

export default Research;
